module.exports = __webpack_public_path__ + "static/rfa-home@2x-1024x908-bf7533c9dffc891cae3ea03b5ee60fba.png";